import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NOT_AVAILABLE, UliActivityType } from '../../common';

@Component({
  selector: 'ui-uli-type',
  templateUrl: './uli-type.component.html',
  styleUrls: ['./uli-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UliTypeComponent {
  @Input() type: UliActivityType;
  @Input() isLabelHidden = false;
  @Input() highlightOutbounds? = false;

  notAvailable = NOT_AVAILABLE;
  uliActivityType = UliActivityType;
}
